/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Rows_With_ErrorsInputs */

const en_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rows had errors`)
};

const fr_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lignes comportaient des erreurs`)
};

const de_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In den Zeilen ${i?.count} traten Fehler auf.`)
};

const it_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} righe contenevano errori`)
};

const ru_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`В строках ${i?.count} были обнаружены ошибки.`)
};

const es_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} filas tenían errores`)
};

const zh_cn2_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 行存在错误`)
};

const ja_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 行にエラーがありました`)
};

const hi_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} पंक्तियों में त्रुटियाँ थीं`)
};

const pt_pt2_knp_terms_rows_with_errors = /** @type {(inputs: Knp_Terms_Rows_With_ErrorsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} linhas continham erros`)
};

/**
* | output |
* | --- |
* | "{count} rows had errors" |
*
* @param {Knp_Terms_Rows_With_ErrorsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_rows_with_errors = /** @type {((inputs: Knp_Terms_Rows_With_ErrorsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Rows_With_ErrorsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_rows_with_errors(inputs)
	if (locale === "de") return de_knp_terms_rows_with_errors(inputs)
	if (locale === "it") return it_knp_terms_rows_with_errors(inputs)
	if (locale === "ru") return ru_knp_terms_rows_with_errors(inputs)
	if (locale === "es") return es_knp_terms_rows_with_errors(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_rows_with_errors(inputs)
	if (locale === "ja") return ja_knp_terms_rows_with_errors(inputs)
	if (locale === "hi") return hi_knp_terms_rows_with_errors(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_rows_with_errors(inputs)
	return en_knp_terms_rows_with_errors(inputs)
});